const inactivateEquipments = {
  toastr: 'Equipamentos atualizados',
  toastr1: 'Equipamentos INATIVADOS com sucesso',
  toastr2: 'Equipamentos REATIVADOS com sucesso',
};

export default inactivateEquipments;
